module.exports = __webpack_public_path__ + "img/msisdn.aef04769.svg";